import type { SVGProps } from 'react'
const PlaceholderGeneric = (props: SVGProps<SVGSVGElement>) => (
  <svg {...props}>
    {
      ' and preserveAspectRatio="xMidYMid slice" should be added for correct rendering thoughout the app -->\n'
    }
    <svg
      preserveAspectRatio="xMidYMid slice"
      viewBox="0 0 1000 500"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <rect width={1000} height={500} fill="#EFEFF4" />
      <path
        d="M429 274.195L481.293 186L530.463 274.195H429Z"
        fill="#DCDCE3"
        style={{
          mixBlendMode: 'multiply',
        }}
      />
      <circle
        cx={525}
        cy={268.732}
        r={45.2683}
        fill="#DCDCE3"
        style={{
          mixBlendMode: 'multiply',
        }}
      />
    </svg>
  </svg>
)
export default PlaceholderGeneric
